import { makeStyles } from "@material-ui/core/styles";

const AddCustomerStyle = makeStyles({
  AddCustomerWrapper: {},
});

export { AddCustomerStyle };
